import React from 'react';
import { Grid, makeStyles, Typography } from '@material-ui/core';

const SubrogationInformation = () => {
  const classes = useStyles();
  return (
    <Grid container className={classes.infoCard}>
      <Typography className={classes.infoTitle}>
        Subrogación de la calidad de suscriptor del servicio público de gas
        domiciliario.
      </Typography>
      <Typography className={classes.infoText} paragraph>
        Es un mecanismo que asegura la continuidad del servicio y la
        transferencia de obligaciones de un titular a otro. La empresa
        prestadora del servicio debe ser notificada de manera adecuada para
        proceder con el cambio de titularidad, asegurando que el nuevo
        propietario asuma todas las responsabilidades, incluyendo cualquier
        deuda pendiente. Este proceso, respaldado por la normativa vigente,
        proporciona seguridad jurídica tanto a las empresas como a los usuarios,
        garantizando una transición ordenada y sin conflictos en la prestación
        del servicio.
      </Typography>
    </Grid>
  );
};

const useStyles = makeStyles(theme => ({
  infoCard: {
    flexWrap: 'wrap',
    backgroundColor: theme.palette.background.cardDark,
    border: 'solid 1px #dbdbdb',
    borderRadius: theme.custom.borderRadius,
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    [`@media (max-width:${theme.breakpoints.values.sm - 1}px)`]: {
      paddingTop: theme.spacing(2.5),
      paddingBottom: theme.spacing(2.5),
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3)
    },
    [`@media (max-width:${theme.breakpoints.values.xm - 1}px)`]: {
      paddingTop: theme.spacing(1.5),
      paddingBottom: theme.spacing(1.5),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }
  },
  infoTitle: {
    fontSize: 15,
    fontWeight: 500,
    marginBottom: theme.spacing()
  },
  infoText: {
    fontSize: 14,
    textAlign: 'justify'
  }
}));

export default SubrogationInformation;
